import request from '@/utils/request'

// 分页查询单元
export function reqUnitPage(data) {
    return request({
        url: '/education/unit/page',
        method: 'post',
        data
    })
}

// 查询单元详情
export function reqUnitDetail(id) {
    return request({
        url: '/education/unit/detail',
        method: 'get',
        params: { id }
    })
}

// 新增单元
export function reqUnitInsert(data) {
    return request({
        url: '/education/unit/insert',
        method: 'post',
        data
    })
}

// 更新单元
export function reqUnitUpdate(data) {
    return request({
        url: '/education/unit/update',
        method: 'post',
        data
    })
}

// 删除单元
export function reqUnitDelete(id) {
    return request({
        url: '/education/unit/delete',
        method: 'get',
        params: { id }
    })
}

// 获取年级分册统计信息（按年级分组）
export function reqGradeVolumeStats() {
    return request({
        url: '/education/unit/gradeVolumeStats',
        method: 'get'
    })
}

// 根据年级ID和分册获取单元列表（不分页）
export function reqUnitsByGradeAndVolume(gradeId, volume) {
    return request({
        url: '/education/unit/listByGradeAndVolume',
        method: 'get',
        params: { gradeId, volume }
    })
}

// 根据年级ID获取分册选项列表（根据学段动态返回）
export function reqVolumeOptions(gradeId) {
    return request({
        url: '/education/unit/volumeOptions',
        method: 'get',
        params: { gradeId }
    })
}

// 批量导入单元（按文件名识别年级与分册，按 Excel sheet 识别单元）
export function reqImportUnits(formData) {
    return request({
        url: '/education/unit/importUnits',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}
